import { Col } from 'antd';

const GridResumenGeneralContrato = ({ budget, budget_iva, totalFiscal, advanceFiscal, advanceFiscalIva, iva }) => {

    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});

    const budgetIva = budget * (budget_iva/100);
    const budgetIvaPlusIva = (iva/100) * budgetIva;
    const contractTotalIva = budgetIva + budgetIvaPlusIva;

    const advanceIva = advanceFiscal * (iva/100);
    const advanceTotalIva = advanceFiscal + advanceIva;

    return (
        <>
            <Col xs={24} md={12}>
                <table style={{ width: "100%", borderSpacing: "0 6px" }}>
                    <tbody>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Porcentaje:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            {numberFormat.format(budget_iva) || "0.00"} %
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Presup. Contrato 1 (con IVA):
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(contractTotalIva) || "0.00"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Anticipo Contrato 1:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(advanceTotalIva) || "0.00"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Total estimado Contrato 1:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(advanceFiscalIva) || "0.00"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Saldo real Contrato 1:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(contractTotalIva- (advanceTotalIva+advanceFiscalIva)) || "0.00"}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>
        </>
    )
}

export default GridResumenGeneralContrato;